import "shikwasa/dist/style.css";
import { Player } from "shikwasa";

// alert(audioUrl);

const player = new Player({
    container: () => document.querySelector("#podcast-player"),
    audio: playerConfig,
    fixed: {
        type: "static",
        position: "bottom",
    },
    theme: "light",
});

// if has ?autoplay=0, prevent it from autoplaying
const urlParams = new URLSearchParams(window.location.search);
const autoplay = urlParams.get("autoplay");
if (autoplay === "0") {
    player.pause();
} else {
    // bypass audio autoplay restriction
    document.addEventListener(
        "click",
        () => {
            if (player.audio.paused) {
                player.play();
            }
        },
        { once: true }
    );
}

// trigger a click event on the player container
document.querySelector("#podcast-player").click();
